import React from "react";

import ForbiddenPageCard from "./ForbiddenPageCard";
import clientLogger from "../domain/services/logging/client.logger";
import loginService from "../domain/services/login.service";
import history from "../providers/history.provider";

const COMPONENT_STACK_MAX_LENGTH = 1000;

class ErrorBoundary extends React.Component {

    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidMount() {
        this.unlisten = history.listen(() => {
            if (this.state.hasError)
                this.setState({ hasError: false });
        });
    }

    componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    }

    componentDidCatch(error, errorInfo) {
        clientLogger.logClientError({
            context: this.props.context || 'react:error-boundary',
            message: (error && error.message) || 'Erro nao tratado na arvore React',
            payload: {
                componentStack: String((errorInfo && errorInfo.componentStack) || '').slice(0, COMPONENT_STACK_MAX_LENGTH),
                wasAuthenticated: loginService.isLogin()
            },
            error
        });
    }

    render() {
        if (!this.state.hasError)
            return this.props.children;

        return (
            <ForbiddenPageCard
                errorMessage="Não foi possível carregar esta tela."
                showRedirectButton
                redirectTo="/"
                redirectButtonText="Recarregar a página"
            />
        );
    }
}

export default ErrorBoundary;
